import React from "react"
import i18n from "@/i18n"
import { TextField } from "@/components/form"

const STYLES = {
  container: "bg-white rounded-lg p-6",
  header: "text-xl font-semibold mb-4 mt-0",
} as const

const Description: React.FC = () => {
  return (
    <div className={STYLES.container} data-testid="settings-venue-description-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.tabbio.description.header")}</h2>
      <TextField
        name="description"
        label={i18n.t("app.settings.venues.tabbio.description.short_description")}
        multiline
        rows={4}
        data-testid="settings-venue-description-input"
      />
    </div>
  )
}

export default Description
